import { lazy } from 'react';

// Narrative Builder — shared entry surface
export const NarrativeList = lazy(() =>
  import('@/capabilities/service-intelligence/pages/narrative/NarrativeList').then((m) => ({ default: m.NarrativeList }))
);

export const NarrativeKindPicker = lazy(() =>
  import('@/capabilities/service-intelligence/pages/narrative/NarrativeKindPicker').then((m) => ({ default: m.NarrativeKindPicker }))
);

export const NarrativeStartPaths = lazy(() =>
  import('@/capabilities/service-intelligence/pages/narrative/NarrativeStartPaths').then((m) => ({ default: m.NarrativeStartPaths }))
);

export const NarrativeBuilderPage = lazy(() =>
  import('@/capabilities/service-intelligence/pages/narrative/NarrativeBuilderPage').then((m) => ({
    default: m.NarrativeBuilderPage,
  }))
);

// Insights
export const ClientBenchmark = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/ClientBenchmark').then((m) => ({ default: m.ClientBenchmark }))
);

export const ComplianceMatrix = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/ComplianceMatrix').then((m) => ({ default: m.ComplianceMatrix }))
);

export const ResolutionFeedInsight = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/ResolutionFeedInsight').then((m) => ({
    default: m.ResolutionFeedInsight,
  }))
);

export const DeliveryPipeline = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/DeliveryPipeline').then((m) => ({ default: m.DeliveryPipeline }))
);

export const EngineerWorkload = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/EngineerWorkload').then((m) => ({ default: m.EngineerWorkload }))
);

export const ClientHealthBoard = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/ClientHealthBoard').then((m) => ({ default: m.ClientHealthBoard }))
);

export const ClientDeepDive = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/ClientDeepDive').then((m) => ({ default: m.ClientDeepDive }))
);

export const CostOfInactionView = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/CostOfInactionView').then((m) => ({ default: m.CostOfInactionView }))
);

export const AutomationOpportunity = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/AutomationOpportunity').then((m) => ({
    default: m.AutomationOpportunity,
  }))
);

export const RevenueProfitability = lazy(() =>
  import('@/capabilities/service-intelligence/pages/insights/RevenueProfitability').then((m) => ({ default: m.RevenueProfitability }))
);

